import { FormItemsBox } from "Components/Shared/FormItemsBox";
import { BlFileInputForm } from "Components/Shared/Inputs/Form/BlFileInputForm";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import { Resources, useResource } from "Translations/Resources";
import type { Control, FieldPath, FieldValues } from "react-hook-form";

type Props<FormType extends FieldValues, TransformedFieldValues = FormType> = {
  control: Control<FormType, unknown, TransformedFieldValues>;
  frontSideName: FieldPath<FormType>;
  backSideName: FieldPath<FormType>;
};

const StepResources = Resources.Onboarding.Steps.Documents;

export const IdentityCardForms = <
  FormType extends FieldValues,
  TransformedFieldValues extends object = FormType,
>({
  control,
  backSideName,
  frontSideName,
}: Props<FormType, TransformedFieldValues>) => {
  const { t } = useResource();

  return (
    <ValuesBox title={t(StepResources.Forms.DocumentTitle)}>
      <FormItemsBox>
        <BlFileInputForm
          control={control}
          label={t(StepResources.Forms.FrontSide)}
          name={frontSideName}
          title={t(StepResources.Forms.DocumentTitle)}
          description={t(StepResources.Forms.DocumentDescription)}
        />
        <BlFileInputForm
          control={control}
          label={t(StepResources.Forms.BackSide)}
          name={backSideName}
          title={t(StepResources.Forms.DocumentTitle)}
          description={t(StepResources.Forms.DocumentDescription)}
        />
      </FormItemsBox>
    </ValuesBox>
  );
};
